import React from 'react';
import { BoxIcon } from 'lucide-react';
export interface ServiceSectionProps {
  title: string;
  paragraphs: string[];
  imagePosition?: 'left' | 'right';
  icon: BoxIcon;
  imageUrl?: string;
}
export function ServiceSection({
  title,
  paragraphs,
  imagePosition = 'right',
  icon: Icon,
  imageUrl
}: ServiceSectionProps) {
  const isImageLeft = imagePosition === 'left';
  return <section className="py-16 sm:py-24 px-4 bg-white even:bg-sky-50/50" data-id="element-149">
      <div className="max-w-7xl mx-auto" data-id="element-150">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-151">
          {/* Text Content */}
          <div className={`flex flex-col ${isImageLeft ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-152">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-6 leading-tight" data-id="element-153">
              {title}
            </h2>
            <div className="space-y-6 text-slate-600 text-lg leading-relaxed" data-id="element-154">
              {paragraphs.map((text, index) => <p key={index} data-id="element-155">{text}</p>)}
            </div>
          </div>

          {/* Image Placeholder */}
          <div className={`relative ${isImageLeft ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-156">
            <div className="aspect-[4/3] w-full rounded-2xl bg-slate-100 border border-slate-200 shadow-inner flex items-center justify-center overflow-hidden group relative z-10" data-id="element-157">
              {imageUrl ? <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-158" /> : <>
                  {/* Decorative background elements */}
                  <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-slate-200 opacity-50" data-id="element-159" />
                  <div className="absolute -right-10 -top-10 w-40 h-40 bg-[#b87333]/10 rounded-full blur-3xl transition-transform group-hover:scale-110 duration-700" data-id="element-160" />
                  <div className="absolute -left-10 -bottom-10 w-40 h-40 bg-[#0c2340]/10 rounded-full blur-3xl transition-transform group-hover:scale-110 duration-700" data-id="element-161" />

                  {/* Icon */}
                  <Icon className="relative w-32 h-32 text-slate-300 transition-transform duration-500 group-hover:scale-105 group-hover:text-slate-400" strokeWidth={1} data-id="element-162" />
                </>}
            </div>

            {/* Subtle decorative accent line */}
            <div className={`absolute -bottom-4 ${isImageLeft ? '-left-4' : '-right-4'} w-24 h-24 bg-[#b87333]/20 rounded-full z-0`} data-id="element-163" />
          </div>
        </div>
      </div>
    </section>;
}